export default {
  // Set goal posts loaded state to true
  goalPostsTimestamp(state) {
    state.goalPostsTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  // Set company reports
  companyReports(state, payload) {
    state.companyReports = payload;
  },
  // Set company goals
  companyGoals(state, payload) {
    state.companyGoals = payload;
  },
  // Set department goals
  departmentGoals(state, payload) {
    state.departmentGoals = payload;
  },
  // Set user reports
  userReports(state, payload) {
    state.userReports = payload;
  },
  // Set user goals
  userGoals(state, payload) {
    state.userGoals = payload;
  },
};
